export default "__VITE_ASSET__CO1Nkg7P__"